<script setup>
  import { onMounted } from 'vue';
  import { useI18n } from 'vue-i18n';
  import { useStageStore } from '@/stores/stage';

  const stageStorage = useStageStore();
  const { t } = useI18n()

  onMounted(() => {
    stageStorage.showMap = false
  })
</script>

<template>
  <div class="container">
    <div class="row">
      <div class="col-md-8 mx-auto text-center border px-4 py-5">
        <h1 class="mb-5">{{ t('404-message') }}</h1>
        <p><router-link to="/">{{ t('router.back-to-start') }}</router-link></p>
      </div>
    </div>
  </div>
</template>